import React, { type FC } from 'react'
import PreviousSVG from './PreviousSVG'
import NextSVG from './NextSVG'

interface IProps {
  goToPreviousQuestion: () => void
  goToNextQuestion: () => void
  isPreviousQuestion: boolean
  isNextQuestion: boolean
  answersLeft: number
  sendResults: () => void
}

const Navigation: FC<IProps> = ({ goToPreviousQuestion, goToNextQuestion, isPreviousQuestion, isNextQuestion, answersLeft, sendResults }) => {
  const getButtonClassName = (type: 'previous' | 'next'): string => {
    const base = 'flex-1 text-xs flex justify-between items-center p-6 transition-colors lg:flex-initial lg:text-base lg:min-w-[12.5rem] lg:px-6'
    if (type === 'previous') {
      if (isPreviousQuestion) {
        return `${base} bg-duskBlack text-pureWhite`
      } else return `${base} bg-duskGrey text-grey`
    } else {
      if (answersLeft === 0) {
        return `${base} bg-duskBlack text-pureWhite`
      } else return `${base} bg-duskGrey text-grey`
    }
  }
  return (
    <div className='flex justify-center gap-6 mb-8'>
      <button
        onClick={goToPreviousQuestion}
        className={getButtonClassName('previous')}
        disabled={!isPreviousQuestion}
      >
        <PreviousSVG stroke={!isPreviousQuestion ? 'rgba(59, 68, 77, 0.50)' : '#FFFFFF'} />
        <span>PREVIOUS</span>
        <span></span>
      </button>
      <button
        onClick={() => {
          isNextQuestion ? goToNextQuestion() : sendResults()
        }}
        className={getButtonClassName('next')}
        disabled={answersLeft > 0}
      >
        <span></span>
        <span>{isNextQuestion ? 'NEXT' : 'RESULTS'}</span>
        <NextSVG stroke={answersLeft > 0 ? 'rgba(59, 68, 77, 0.50)' : '#FFFFFF'} />
      </button>
    </div>
  )
}

export default Navigation
